import { DataRoomCustomFolder } from "@/models/data-room/DataRoomCustomFolder";
import { DataRoomFileSection } from "@/pages/OneDataRoomFilesPage";
import { DataRoomEntry } from "@/pages/OneDataRoomPage";
import { Dispatch, SetStateAction, createContext, useCallback, useContext, useState } from "react";
import { MASTER_ENTRY } from "../DataRoomCategoriesDefines";
import { TREE_FILTERS } from "../DataRoomDirectoryFileTree";

type Props = {
  closeAll: boolean;
  setCloseAll: Dispatch<SetStateAction<boolean>>;
  selected: DataRoomEntry;
  setSelected: (v: DataRoomEntry) => void;
  selectedCustom: DataRoomCustomFolder;
  setSelectedCustom: (v: DataRoomCustomFolder) => void;
  // matches?: DATA_ROOM_STATIC_ID[];
  section: DataRoomFileSection;
  setSection: Dispatch<SetStateAction<DataRoomFileSection>>;
  treeFilter: TREE_FILTERS;
  setTreeFilter: Dispatch<SetStateAction<TREE_FILTERS>>;
};

const Context = createContext(undefined);

export function DataRoomProvider({ children }) {
  const [selected, setSelected] = useState<DataRoomEntry | DataRoomCustomFolder>(MASTER_ENTRY);
  const [selectedCustom, setSelectedCustom] = useState<DataRoomCustomFolder>(null);
  const [closeAll, setCloseAll] = useState<boolean>(false);
  const [section, setSection] = useState<DataRoomFileSection>(DataRoomFileSection.MANAGE);
  const [treeFilter, setTreeFilter] = useState<TREE_FILTERS>(TREE_FILTERS.COMMON);

  const onFolderSelection = useCallback((v: DataRoomEntry) => {
    if (v != null) {
      setSelected(v);
    } else {
      setSelected(MASTER_ENTRY);
    }
    setSection(DataRoomFileSection.MANAGE);
  }, []);

  const onCloseAll = useCallback((c: boolean) => {
    if (c) {
      setSelected(MASTER_ENTRY);
    }
    setCloseAll(c);
  }, []);

  return (
    <Context.Provider
      value={{
        selected,
        setSelected: onFolderSelection,
        closeAll,
        setCloseAll: onCloseAll,
        section,
        setSection,
        selectedCustom,
        setSelectedCustom,
        treeFilter,
        setTreeFilter,
      }}
    >
      {children}
    </Context.Provider>
  );
}

export function useDataRoomProvider(): Props {
  return useContext(Context);
}
